import crudAction from './actions'

export default {
  name: 'notification',
  namespace: 'notifications',
  methods: [
    ...crudAction,
  ]
}
